<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
            size="small"
            clearable
            placeholder="请选择提现状态"
            v-model="conditionQuery.auditState"
            class="mr10"
            filterable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已发放" value="agree"></el-option>
          <el-option label="已驳回" value="refuse"></el-option>
          <el-option label="申请中" value="wait"></el-option>
        </el-select>
        <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="queryTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="请选择提现时段"
            end-placeholder="请选择提现时段"
        ></el-date-picker>
        <el-input
            clearable
            v-model.trim="conditionQuery.keyWord"
            placeholder="请输入提现号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>

    </div>
    <div class="table">
      <el-table
          :data="list"
          style="width: 100%"
          ref="table"
          stripe
          border
          size="small"
      >
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="提现单号"
            prop="getcashSn"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="提现申请时间"
            prop="getcachApplyTime"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="提现金额"
            prop="getcashMoney"
        >
          <template slot-scope="scope">
            ￥{{scope.row.getcashMoney}}
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="提现申请人"
            prop="getcashName"
            width="200px"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="auditState"
            label="提现状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.auditState === 'agree'" style="color: green" >已发放</div>
            <div v-if="scope.row.auditState === 'refuse'" style="color: red">已驳回</div>
            <div v-if="scope.row.auditState === 'wait'">申请中</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      isOutputing: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      isRedpackageSupplier: false,
      storeName: "",
      queryTime:[],
      conditionQuery:{
        auditState:'',
        keyWord:''
      },
    };
  },
  created() {
    // this.queryList();
  },
  mounted() {
    if (this.$route.query.storeCode) {
      this.isRedpackageSupplier = true;
      this.storeName = localStorage.getItem("storeName");
    }
    this.queryList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      const condition = JSON.parse(JSON.stringify(this.conditionQuery));
      if(this.queryTime){
        condition.queryStartTime = this.queryTime[0];
        condition.queryEndTime = this.queryTime[1];
      }
      Object.assign(params,condition)
      const { result } = await this.$store.dispatch("cash_out_list",params);
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
